import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Grid, Button, Typography, Divider, CardContent, List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import DescriptionTwoToneIcon from '@mui/icons-material/DescriptionTwoTone';
// import MainCard from 'ui-component/cards/MainCard';
const DeleteModal = ({ open, closeModal, dataDelete, handleConfirm }) => {
    console.log(dataDelete);
    return (
        <Modal open={open} onClose={closeModal} aria-labelledby="simple-modal-title" aria-describedby="simple-modal-description">
            <Grid container justifyContent="center" alignItems="center" height="100%">
                <div style={{ backgroundColor: 'white', padding: '20px', borderRadius: '8px', maxWidth: '400px' }}>
                    {/* Modal Title */}
                    <CardContent>
                        <Typography variant="h3" id="simple-modal-title" gutterBottom>
                            Bạn muốn xóa tài liệu?
                        </Typography>
                        <Divider />
                        {/* Modal Content */}
                        <Typography sx={{ mt: 2 }} id="simple-modal-description" paragraph>
                            Vui lòng kiểm tra kỹ các nội dung sẽ xóa:
                        </Typography>
                        <List component="nav" aria-label="main mailbox folders">
                            {dataDelete.map((data, index) => {
                                return (
                                    <ListItemButton sx={{ borderRadius: `8px` }} key={index}>
                                        <ListItemIcon>
                                            <DescriptionTwoToneIcon sx={{ fontSize: '1.3rem' }} />
                                        </ListItemIcon>
                                        <ListItemText primary={data} />
                                    </ListItemButton>
                                );
                            })}

                            {/* <ListItemButton
                  sx={{ borderRadius: `8px`, mt: 0.625 }}
                >
                  <ListItemIcon>
                    <UploadFileTwoTone sx={{ fontSize: '1.3rem' }} />
                  </ListItemIcon>
                  <ListItemText primary="Upload file" secondary="Cung cấp file từ thiết bị" />
                </ListItemButton> */}
                        </List>
                    </CardContent>
                    {/* Action Buttons */}
                    <Grid container justifyContent="flex-end" sx={{ marginTop: 2 }}>
                        <Button variant="outlined" color="secondary" onClick={closeModal}>
                            Thoát
                        </Button>
                        <Button variant="outlined" color="primary" onClick={handleConfirm} sx={{ marginLeft: 2 }}>
                            Đồng ý
                        </Button>
                    </Grid>
                </div>
            </Grid>
        </Modal>
    );
};

DeleteModal.propTypes = {
    open: PropTypes.bool.isRequired,
    closeModal: PropTypes.func.isRequired
    // handleConfirm: PropTypes.func.isRequired,
};

export default DeleteModal;
